import React, { useState } from "react";

export default function ReferencesAndChainOfThought({ references, count, chain_of_thought }) {
    console.log("ReferencesAndChainOfThought", { references, count, chain_of_thought });
  const [expanded, setExpanded] = useState(false);
  const hasChain =  Array.isArray(chain_of_thought) && chain_of_thought.length > 0;
  const hasReferences = Array.isArray(references) && references.length > 0;
  const showButton = hasReferences || chain_of_thought !== undefined;

  return (
    <div style={{ margin: "6px 0 12px 0", padding: "8px", background: "#f7faff", borderRadius: 8 }}>
      {/* Source count always on top if references exist */}
      {hasReferences && (
        <div style={{ fontWeight: 'bold', marginBottom: 6 }}>
          Sources: {count || references.length} Reference{(count || references.length) === 1 ? '' : 's'}
        </div>
      )}
      {/* Expand/collapse button always shown if chain_of_thought is present (even if empty) */}
      {showButton && (
        <button
          style={{
            background: '#e3f0fa',
            color: '#1a3556',
            border: '1px solid #7eb6e6',
            borderRadius: 4,
            padding: '4px 10px',
            fontSize: 14,
            cursor: 'pointer',
            marginBottom: 6,
            outline: 'none',
          }}
          onClick={() => setExpanded(e => !e)}
        >
          {expanded ? 'Hide Details' : 'Show Details'}
        </button>
      )}
      {/* Expanded view: references first, then chain of thought timeline or 'Answered from memory' */}
      {expanded && (
        <div>
          {hasReferences && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Data shown here is sourced from:</div>
              {references.map((ref, i) => {
                const url = typeof ref === "string" ? ref : ref.url || ref.citation;
                if (!url) return null;
                return (
                  <div key={i} style={{ marginBottom: 6 }}>
                    <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "underline", wordBreak: "break-all" }}>
                      {url}
                    </a>
                  </div>
                );
              })}
            </div>
          )}
          {/* Chain of thought timeline or answered from memory */}
          <div>
            <div style={{ fontWeight: 'bold', marginBottom: 6 }}>Train of Thought</div>
            {hasChain ? (
              <div>
                {chain_of_thought.map((step, idx) => {
                  // Alternate between two more vibrant colors for contrast
                  const bgColor = idx % 2 === 0 ? '#e6f7ff' : '#fffbe6';
                  const leftColor = idx % 2 === 0 ? '#1890ff' : '#faad14';
                  const rightColor = idx % 2 === 0 ? '#0050b3' : '#ad6800';
                  // Placeholder logic based on tool name
                  let placeholder = '';
                  if (step.name === 'execute_sql_query') {
                    placeholder = 'SQL Query';
                  } else if (step.name === 'vector_search') {
                    placeholder = 'Vector Search Query';
                  } else if (step.name === 'web_search') {
                    placeholder = 'Web Search Query';
                  } else if (step.name === 'api_call') {
                    placeholder = 'API Call';
                  } else if (step.name) {
                    placeholder = step.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                  }
                  return (
                    <div
                      key={idx}
                      style={{
                        background: bgColor,
                        padding: '10px 16px',
                        borderRadius: 12,
                        marginBottom: 10,
                        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                        border: 'none',
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 24 }}>
                        <div style={{ fontWeight: 'bold', color: leftColor, flex: 1, textAlign: 'left' }}>
                          {placeholder}
                        </div>
                        <div style={{ flex: 2, fontStyle: 'italic', textAlign: 'center', padding: '0 10px' }}>
                          {step.reason || ''}
                        </div>
                        <div style={{ color: rightColor, flex: 2, textAlign: 'right', fontStyle: 'italic' }}>
                          {step.arguments || <span style={{ color: '#bbb' }}>{placeholder}</span>}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ color: '#888', fontStyle: 'italic', marginBottom: 8 }}>
                Answered from memory
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
